module.exports = __webpack_public_path__ + "f941869dd5f3009d58ac5a7476f1a8c6.svg";